import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { useApi } from "@shopexperts/shared";

export function useExpertFilterOptions() {
  const api = useApi();

  const { data, isLoading, error } = useQuery({
    queryKey: ["admin", "experts", "filter-options"],
    queryFn: async () => {
      return await api.admin.expertManager.getFilterOptions();
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

  const filterOptions = computed(() => data.value ?? {
    statuses: [],
    expert_types: [],
    countries: [],
    service_categories: [],
    languages: [],
    partner_tiers: [],
    claim_statuses: [],
  });

  return {
    filterOptions,
    isLoading,
    error,
  };
}
